const CIS_COUNTRIES = ['UA', 'AZ', 'AM', 'BY', 'KZ', 'KG', 'MD', 'TJ', 'UZ'];

const CIS_DELIVERY_COUNTRIES = ['UA', 'AZ', 'AM', 'BY', 'KZ', 'KG', 'MD', 'TJ', 'UZ', 'RU'];

export { CIS_COUNTRIES, CIS_DELIVERY_COUNTRIES };
